import { FormattedMessage } from 'react-intl';

interface GuideLogoProps {
  picture: string;
  tourName: string;
  guideName: string;
}

export const GuideLogo = ({ picture, tourName, guideName }: GuideLogoProps) => (
  <div className="CoverGuideLogo">
    <img alt="Guide Logo" src={picture} className="guide-logo" />
    <span className="text">
      <span className="title">
        <span className="name">{tourName}</span>
      </span>
      <span className="guide">
        <FormattedMessage
          defaultMessage="with {guideName}"
          description="Guide name"
          values={{ guideName }}
        />
      </span>
    </span>
  </div>
);
